import React, { useEffect, useRef } from "react";
import { useQuill } from "react-quilljs";
import "quill/dist/quill.snow.css";

const QuillBox = ({ initialText }) => {
  const theme = "snow";
  const modules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["link"],
      [{ color: [] }, { background: [] }],
    ],
  };

  const placeholder = "Compose an epic...";

  const { quillRef } = useQuill({ theme, modules, placeholder });

  useEffect(() => {
    if (quillRef.current) {
      quillRef.current.innerHTML = initialText; 
    }
  }, [quillRef, initialText]);

  return (
    <div className="comment-box">
      <div
        className="comment-textbox"
        style={{
          height: 160,
          paddingBottom: "3rem"
        }}
        ref={quillRef}
      />
    </div>
  );
};

export default QuillBox;
